import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import { Colors } from "../../../utils/budget-tool-specific";
import iframeErrorLogger from "../../../utils/iframe-error-logger";

const BudgetCalculator = (props) => {
    const iframeRef = useRef(null);

    useEffect(() => {
        // Initialize iframe error logging when component mounts
        if (iframeRef.current) {
            iframeErrorLogger.initializeIframeErrorLogging(
                iframeRef.current,
                'budget-calculator'
            );
        }

        // Cleanup function
        return () => {
            // Cleanup will be handled by the singleton instance
            console.log('Budget calculator component unmounting');
        };
    }, []);

    const handleIframeLoad = () => {
        console.log('Budget calculator iframe loaded successfully');

        // Re-initialize error logging after iframe loads
        if (iframeRef.current) {
            iframeErrorLogger.initializeIframeErrorLogging(
                iframeRef.current,
                'budget-calculator'
            );
        }
    };

    const handleIframeError = (event) => {
        console.error('Budget calculator iframe failed to load:', event);

        // Log iframe load failure
        iframeErrorLogger.logError({
            application: 'budget-calculator',
            errorType: 'iframe-load-error',
            error: {
                message: 'Budget calculator iframe failed to load',
                name: 'IframeLoadError',
                stack: null
            },
            severity: 'error',
            url: 'https://monikerbudgetcalculator.netlify.app/',
            additionalContext: {
                iframeSrc: 'https://monikerbudgetcalculator.netlify.app/',
                parentUrl: window.location.href,
                loadError: true
            }
        });
    };

    return (
        <PageContainer>
            <WideContainer>
                <Row>
                    <Col>
                        <HeaderTitle>
                            Budget Calculator
                        </HeaderTitle>
                        <p>Use our interactive budget calculator to get instant estimates for your corporate retreat.</p>
                        <Spacer height="20px" />
                        <IframeContainer>
                            <iframe
                                ref={iframeRef}
                                id="budget-calculator-iframe"
                                src="https://monikerbudgetcalculator.netlify.app/"
                                title="Moniker Budget Calculator"
                                width="1300px"
                                height="1200px"
                                frameBorder="0"
                                allowFullScreen
                                onLoad={handleIframeLoad}
                                onError={handleIframeError}
                                style={{
                                    border: 'none',
                                    borderRadius: '8px',
                                    width: '1300px',
                                    maxWidth: '1300px',
                                    display: 'block',
                                    margin: '0 auto'
                                }}
                            />
                        </IframeContainer>
                    </Col>
                </Row>
            </WideContainer>
        </PageContainer>
    );
};

export default BudgetCalculator;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;

const Spacer = styled.div`
    height: ${props => props.height || '20px'};
`;

const IframeContainer = styled.div`
    background-color: white;
    border-radius: 10px;
    padding: 15px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 100px;
    overflow: hidden;
    width: 100%;
    max-width: 100%;
    min-height: 1020px;
`;

const WideContainer = styled.div`
    padding: 0;
    margin: 0;
    width: 100%;
    max-width: 100%;
`;

const HeaderTitle = styled.h2`
    color: ${Colors.primaryDark};
    margin-top: 30px;
    margin-bottom: 0px;
    padding-left: 15px;
`;

const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
`;

const Col = styled.div`
    flex: 1;
    padding-right: 15px;
    padding-left: 15px;
`; 